module.exports = __webpack_public_path__ + "static/media/Devin Colston.08901efc.png";